import React from 'react'

const HomeAbout = () => {
  return (
    <div>
        <div className="container py-5">
            <div className='row'>
                <div className='col-md-12'>
                    <h2 className="mb-4 fw-bold heading text-center">Expert Study Abroad Counselling in Bangalore</h2>
                    <p className="mb-4 text-center text-muted">  Your trusted study abroad consultants for global education success, offering expert guidance for university selection, applications, and visa processes across top destinations.
We provide personalized support at every step, helping you confidently achieve your international education and career goals.
 </p>
                </div>
            </div>

        </div>
    </div>
  )
}

export default HomeAbout